import { useQuery } from "react-query";
import { useClient } from "hooks";

export const useActionsQuery = (config) => {
  const client = useClient();

  return useQuery({
    queryKey: ["wp_connect_actions"],
    queryFn: async () => client.get("wp_connect_actions").get("data"),
    ...config,
  });
};
